import { Option } from '@/models/interfaces';
import toKey from '@/utils/toKey';

const BEL_ZIP_TABLE: { [code: string]: { aL4: string; aL6: string } } = {
  '1000': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1020': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1030': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1040': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1050': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1060': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1070': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1080': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1081': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1082': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1083': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1090': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1120': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1130': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1140': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1150': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1160': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1170': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1180': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1190': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1200': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1210': {
    aL4: 'Bruxelles‑Capitale',
    aL6: 'Bruxelles‑Capitale',
  },
  '1300': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1301': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1310': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1315': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1320': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1325': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1330': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1331': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1332': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1340': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1341': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1342': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1348': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1350': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1357': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1360': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1367': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1370': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1380': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1390': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1400': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1401': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1402': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1404': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1410': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1430': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1435': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1440': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1450': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1457': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1460': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1461': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1470': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1471': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1472': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1473': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1474': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1476': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1480': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1490': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1495': {
    aL4: 'Wallonie',
    aL6: 'Brabant wallon',
  },
  '1500': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1501': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1502': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1540': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1547': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1560': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1570': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1600': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1601': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1602': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1620': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1630': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1640': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1650': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1651': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1652': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1653': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1654': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1670': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1671': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1673': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1674': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1700': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1701': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1702': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1703': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1730': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1731': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1740': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1741': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1742': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1745': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1750': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1755': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1760': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1761': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1770': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1780': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1785': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1790': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1800': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1820': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1830': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1831': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1840': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1850': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1851': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1852': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1853': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1860': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1861': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1880': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1910': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1930': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1932': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1933': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1950': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1970': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1980': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1981': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '1982': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '2000': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2018': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2020': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2030': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2040': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2050': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2060': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2100': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2110': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2140': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2150': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2160': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2170': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2180': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2200': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2220': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2221': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2222': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2223': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2230': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2235': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2240': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2242': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2243': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2250': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2260': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2270': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2275': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2280': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2288': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2290': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2300': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2310': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2320': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2321': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2322': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2323': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2328': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2330': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2340': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2350': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2360': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2370': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2380': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2381': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2382': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2387': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2390': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2400': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2430': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2431': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2440': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2450': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2460': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2470': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2480': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2490': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2491': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2500': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2520': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2530': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2531': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2540': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2547': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2550': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2560': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2570': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2580': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2590': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2600': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2610': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2620': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2627': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2630': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2640': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2650': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2660': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2800': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2801': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2811': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2812': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2820': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2830': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2840': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2845': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2850': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2860': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2861': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2870': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2880': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2890': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2900': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2910': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2920': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2930': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2940': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2950': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2960': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2970': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2980': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '2990': {
    aL4: 'Flandre',
    aL6: 'Anvers',
  },
  '3000': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3001': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3010': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3012': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3018': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3020': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3040': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3050': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3051': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3052': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3053': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3054': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3060': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3061': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3070': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3071': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3078': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3080': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3090': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3110': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3111': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3118': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3120': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3128': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3130': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3140': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3150': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3190': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3191': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3200': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3201': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3202': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3210': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3211': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3212': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3220': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3221': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3270': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3271': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3272': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3290': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3293': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3294': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3300': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3320': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3321': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3350': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3360': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3370': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3380': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3381': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3384': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3390': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3391': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3400': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3401': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3404': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3440': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3450': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3454': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3460': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3461': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3470': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3471': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3472': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3473': {
    aL4: 'Flandre',
    aL6: 'Brabant flamand',
  },
  '3500': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3501': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3510': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3511': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3512': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3520': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3530': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3540': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3545': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3550': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3560': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3570': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3580': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3581': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3582': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3583': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3590': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3600': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3620': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3621': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3630': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3631': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3640': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3650': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3660': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3665': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3668': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3670': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3680': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3690': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3700': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3717': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3720': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3721': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3722': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3723': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3724': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3730': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3740': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3770': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3790': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3791': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3792': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3793': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3798': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3800': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3803': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3806': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3830': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3831': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3832': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3840': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3850': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3870': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3890': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3891': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3900': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3910': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3920': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3930': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3940': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3941': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3950': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3960': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3970': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3971': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3980': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '3990': {
    aL4: 'Flandre',
    aL6: 'Limbourg',
  },
  '4000': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4020': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4030': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4031': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4032': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4040': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4041': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4042': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4050': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4051': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4052': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4053': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4100': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4101': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4102': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4120': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4121': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4122': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4130': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4140': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4141': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4160': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4161': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4162': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4163': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4170': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4171': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4180': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4181': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4190': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4210': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4217': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4218': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4219': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4250': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4252': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4253': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4254': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4257': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4260': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4261': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4263': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4280': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4287': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4300': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4317': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4340': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4342': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4347': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4350': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4351': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4357': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4360': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4367': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4400': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4420': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4430': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4431': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4432': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4450': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4451': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4452': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4453': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4458': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4460': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4470': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4480': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4500': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4520': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4530': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4537': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4540': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4550': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4557': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4560': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4570': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4577': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4590': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4600': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4601': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4602': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4606': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4607': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4608': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4610': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4620': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4621': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4623': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4624': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4630': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4631': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4632': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4633': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4650': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4651': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4652': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4653': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4654': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4680': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4681': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4682': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4683': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4684': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4690': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4700': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4701': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4710': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4711': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4720': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4721': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4728': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4730': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4731': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4750': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4760': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4761': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4770': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4771': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4790': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4791': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4800': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4801': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4802': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4820': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4821': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4830': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4831': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4834': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4837': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4840': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4841': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4845': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4850': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4851': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4852': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4860': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4861': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4870': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4877': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4880': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4890': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4900': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4910': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4920': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4950': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4960': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4970': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4980': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4983': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4987': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '4990': {
    aL4: 'Wallonie',
    aL6: 'Liège',
  },
  '5000': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5001': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5002': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5003': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5004': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5020': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5021': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5022': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5024': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5030': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5031': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5032': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5060': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5070': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5080': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5081': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5100': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5101': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5140': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5150': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5170': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5190': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5300': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5310': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5330': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5332': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5333': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5334': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5336': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5340': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5350': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5351': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5352': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5353': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5354': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5360': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5361': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5362': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5363': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5364': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5370': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5372': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5374': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5376': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5377': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5380': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5500': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5501': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5502': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5503': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5504': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5520': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5521': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5522': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5523': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5524': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5530': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5537': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5540': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5541': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5542': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5543': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5544': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5550': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5555': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5560': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5561': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5562': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5563': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5564': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5570': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5571': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5572': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5573': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5574': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5575': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5576': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5580': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5590': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5600': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5620': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5621': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5630': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5640': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5641': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5644': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5646': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5650': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5651': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5660': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5670': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '5680': {
    aL4: 'Wallonie',
    aL6: 'Namur',
  },
  '6000': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6001': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6010': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6020': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6030': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6031': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6032': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6040': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6041': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6042': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6043': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6044': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6060': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6061': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6110': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6111': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6150': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6180': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6181': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6182': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6183': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6200': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6210': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6211': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6220': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6221': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6222': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6223': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6224': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6230': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6238': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6240': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6250': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6280': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6440': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6441': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6460': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6461': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6462': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6463': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6464': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6470': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6500': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6511': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6530': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6531': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6532': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6533': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6534': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6536': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6540': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6542': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6543': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6560': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6567': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6590': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6591': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6592': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6593': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6594': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6596': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '6600': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6630': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6637': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6640': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6642': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6660': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6661': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6662': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6663': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6666': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6670': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6671': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6672': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6673': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6674': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6680': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6681': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6686': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6687': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6688': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6690': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6692': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6698': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6700': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6704': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6706': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6717': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6720': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6721': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6723': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6724': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6730': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6740': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6741': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6742': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6743': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6747': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6750': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6760': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6761': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6762': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6767': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6769': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6780': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6781': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6782': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6790': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6791': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6792': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6800': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6810': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6811': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6812': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6813': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6820': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6821': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6823': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6824': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6830': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6831': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6832': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6833': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6834': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6836': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6838': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6840': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6850': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6851': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6852': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6853': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6856': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6860': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6870': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6880': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6887': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6890': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6900': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6920': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6921': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6922': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6924': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6927': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6929': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6940': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6941': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6950': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6951': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6952': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6953': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6960': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6970': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6971': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6972': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6980': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6982': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6983': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6984': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6986': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6987': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6990': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '6997': {
    aL4: 'Wallonie',
    aL6: 'Luxembourg',
  },
  '7000': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7011': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7012': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7020': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7021': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7022': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7024': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7030': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7031': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7032': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7033': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7034': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7040': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7041': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7050': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7060': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7061': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7062': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7063': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7070': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7080': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7090': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7100': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7110': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7120': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7130': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7131': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7133': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7134': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7140': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7141': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7160': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7170': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7180': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7181': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7190': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7191': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7300': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7301': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7320': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7321': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7322': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7330': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7331': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7332': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7333': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7334': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7340': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7350': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7370': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7380': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7382': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7387': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7390': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7500': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7501': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7502': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7503': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7504': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7506': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7520': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7521': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7522': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7530': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7531': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7532': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7533': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7534': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7536': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7538': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7540': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7542': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7543': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7548': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7600': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7601': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7602': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7603': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7604': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7608': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7610': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7611': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7618': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7620': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7621': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7622': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7623': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7624': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7640': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7641': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7642': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7643': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7700': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7711': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7712': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7730': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7740': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7742': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7743': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7760': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7780': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7781': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7782': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7783': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7784': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7800': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7801': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7802': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7803': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7804': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7810': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7811': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7812': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7822': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7823': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7830': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7850': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7860': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7861': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7862': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7863': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7864': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7866': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7870': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7880': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7890': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7900': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7901': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7903': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7904': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7906': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7910': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7911': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7912': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7940': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7941': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7942': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7943': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7950': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7951': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7970': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7971': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7972': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '7973': {
    aL4: 'Wallonie',
    aL6: 'Hainaut',
  },
  '8000': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8020': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8200': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8210': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8211': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8300': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8301': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8310': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8340': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8370': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8377': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8380': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8400': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8420': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8421': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8430': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8431': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8432': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8433': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8434': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8450': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8460': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8470': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8480': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8490': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8500': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8501': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8510': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8511': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8520': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8530': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8531': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8540': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8550': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8551': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8552': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8553': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8554': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8560': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8570': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8572': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8573': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8580': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8581': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8582': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8583': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8587': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8600': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8610': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8620': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8630': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8640': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8647': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8650': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8660': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8670': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8680': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8690': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8691': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8700': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8710': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8720': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8730': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8740': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8750': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8755': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8760': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8770': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8780': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8790': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8791': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8792': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8793': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8800': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8810': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8820': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8830': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8840': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8850': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8851': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8860': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8870': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8880': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8890': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8900': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8902': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8904': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8906': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8908': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8920': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8930': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8940': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8950': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8951': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8952': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8953': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8954': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8956': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8957': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8958': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8970': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8972': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8978': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '8980': {
    aL4: 'Flandre',
    aL6: 'Flandre occidentale',
  },
  '9000': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9030': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9031': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9032': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9040': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9041': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9042': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9050': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9051': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9052': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9060': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9070': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9080': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9090': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9100': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9111': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9112': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9140': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9150': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9160': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9170': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9180': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9185': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9190': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9200': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9220': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9230': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9240': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9250': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9255': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9260': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9270': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9280': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9290': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9300': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9308': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9310': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9320': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9340': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9400': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9401': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9402': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9403': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9404': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9406': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9420': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9450': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9451': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9470': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9472': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9473': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9500': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9506': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9520': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9521': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9550': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9551': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9552': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9570': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9571': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9572': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9600': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9620': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9630': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9636': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9660': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9661': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9667': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9680': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9681': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9688': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9690': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9700': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9750': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9770': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9771': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9772': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9790': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9800': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9810': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9820': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9830': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9831': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9840': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9850': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9860': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9870': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9880': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9881': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9890': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9900': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9910': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9920': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9921': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9930': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9931': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9932': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9940': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9950': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9960': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9961': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9968': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9970': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9971': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9980': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9981': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9982': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9988': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9990': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9991': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
  '9992': {
    aL4: 'Flandre',
    aL6: 'Flandre orientale',
  },
};

const BEL_OPTIONS: Array<Option> = [
  { value: 'bruxelles‑capitale', label: 'Bruxelles‑Capitale' },
  { value: 'flandre', label: 'Flandre' },
  { value: 'anvers', label: '↳ Anvers' },
  { value: 'brabant_flamand', label: '↳ Brabant flamand' },
  { value: 'flandre_occidentale', label: '↳ Flandre occidentale' },
  { value: 'flandre_orientale', label: '↳ Flandre orientale' },
  { value: 'limbourg', label: '↳ Limbourg' },
  { value: 'wallonie', label: 'Wallonie' },
  { value: 'brabant_wallon', label: '↳ Brabant wallon' },
  { value: 'hainaut', label: '↳ Hainaut' },
  { value: 'liege', label: '↳ Liège' },
  { value: 'luxembourg', label: '↳ Luxembourg' },
  { value: 'namur', label: '↳ Namur' },
];

function getBelgiumOSM(input: string): { aL6: string; aL4: string } | null {
  let found: { aL6: string; aL4: string } | undefined = undefined;
  if (parseInt(input)) {
    found = BEL_ZIP_TABLE[input];
    if (found) found = JSON.parse(JSON.stringify(found));
  }
  if (!found) {
    found = Object.values(BEL_ZIP_TABLE).find((it) => input == toKey(it.aL6));
    if (found) found = JSON.parse(JSON.stringify(found));
  }
  if (!found) {
    found = Object.values(BEL_ZIP_TABLE).find((it) => input == toKey(it.aL4));
    if (found) found = JSON.parse(JSON.stringify(found));
    if (found) found.aL6 = '';
  }
  return found ?? null;
}

export { BEL_OPTIONS, getBelgiumOSM };
